/*=========================================================================================
  File Name: moduleTronBot.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Daniyal
==========================================================================================*/


import state from './moduleMetaMaskState.js'
import mutations from './moduleMetaMaskMutations.js'
import actions from './moduleMetaMaskActions.js'
import getters from './moduleMetaMaskGetters.js'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}